module.exports = __webpack_public_path__ + "images/kyotolease_smalle4795001abb8df22a9beda30525102ce.png";